import { Link } from "react-router-dom";
import { Check } from "lucide-react";
import { BOOKING_URL } from "@/data/site";

export const ServiceCard = ({ service, highlight = false }) => (
  <div data-testid={`service-card-${service.id}`}
    className={`bg-white border p-6 sm:p-8 flex flex-col rounded-sm transition-[transform,box-shadow] duration-300 ease-out hover:-translate-y-1 hover:shadow-lg ${highlight ? "border-brand border-2" : "border-zinc-200"}`}>
    {highlight && <span className="text-xs tracking-[0.2em] uppercase font-bold text-brand mb-2">Most Popular</span>}
    <h3 className="font-heading font-bold text-xl sm:text-2xl tracking-tight text-brand-ink">{service.name}</h3>
    <div className="mt-3 mb-1 flex items-baseline gap-2">
      <span data-testid={`service-price-${service.id}`} className="font-heading font-black text-4xl text-brand">{service.price}</span>
      <span className="text-sm text-zinc-500">{service.unit}</span>
    </div>
    <p className="text-sm text-zinc-600 mb-5">{service.tagline}</p>
    <ul className="space-y-2 mb-6 flex-1">
      {service.features.map((f) => (
        <li key={f} className="flex items-start gap-2 text-sm text-zinc-700">
          <Check className="w-4 h-4 text-brand shrink-0 mt-0.5" /> {f}
        </li>
      ))}
    </ul>
    {service.quote ? (
      <Link to="/contact" data-testid={`service-quote-btn-${service.id}`}
        className="block text-center border-2 border-brand text-brand hover:bg-brand hover:text-white font-bold py-3 rounded-sm transition-colors duration-200">
        Get a Free Quote
      </Link>
    ) : (
      <a href={BOOKING_URL} target="_blank" rel="noopener noreferrer" data-testid={`service-book-btn-${service.id}`}
        className={`block text-center font-bold py-3 rounded-sm transition-colors duration-200 ${highlight ? "bg-brand text-white hover:bg-brand-dark" : "bg-brand-ink text-white hover:bg-brand"}`}>
        Book Now
      </a>
    )}
  </div>
);
